import styled from "@emotion/styled";

export const Root = styled.div`
  background-color: #060f16;
  font-family: "Roboto", serif;
  font-weight: 300;
  height: 100vh;
  margin: 0 auto;
  overflow: auto;
  text-align: center;
  width: 100%;
  .loadingWrap {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    svg {
      height: 100px;
      width: 100px;
    }
  }
  .gridWrap {
    display: grid;
    flex-grow: 1;
    gap: 14px;
    grid-auto-rows: 1fr;
    grid-template-rows: auto auto 1fr;
    grid-template-columns: 2.5fr 2.5fr 7fr;
    margin: 0 auto;
    max-width: 1440px;
    max-height: calc(100vh - 66px);
    height: 100vh;
    box-sizing: border-box;
    padding: 24px 28px;
    width: 100%;
    h2 {
      margin: 0;
    }
  }

  .smallCard {
    background-color: #1a253e;
    padding: 20px 8px;
    border-radius: 5px;
    color: #fff;
    /* grid-column: 1 / 2; */
    grid-column: span 1;
  }

  .smallCardGreen {
    background-color: #71bc7e;
    color: #1a253e;
  }

  .smallCard .cardTitle {
    font-size: 18px;
    font-weight: 700;
    @media (min-width: 1440px) {
      font-size: 25px;
    }
  }

  .smallCard .thisWeek {
    font-size: 10px;
    font-weight: 400;
    text-transform: uppercase;
    @media (min-width: 1440px) {
      font-size: 12px;
    }
  }

  .smallCard .cardValue {
    font-size: 48px;
    font-weight: 700;
    margin-top: 16px;
    line-height: 1;
    svg {
      max-width: 60px;
      height: auto;
    }
    @media (min-width: 1440px) {
      font-size: 65px;
    }
  }

  /* SETLLMENTS BY CLOSRS CARD */

  .closers {
    background-color: #1a253e;
    border-radius: 5px;
    color: #fff;
    display: flex;
    grid-column: 1 / 3;
    grid-row: 2 / 4;
    padding: 40px 28px;
    flex-direction: column;
  }

  .closersHeader {
    font-size: 25px;
    font-weight: 700;
    text-align: center;
    line-height: 1;
    // dont shrink
    flex-shrink: 0;
  }
  .closersHeaderWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .legendWrap {
    /* flex-shrink: 0; */
    display: flex;
    column-gap: 0px;
    row-gap: 0px;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-end;
    @media (min-width: 1440px) {
      column-gap: 36px;
    }
  }

  .legendItem {
    padding-left: 0px;
    display: flex;
    height: 26px;
    font-weight: 400;
    align-items: center;
    color: #d4c92c;
    font-weight: 400;
    font-size: 12px;
    width: 40%;
    text-align: right;
    justify-content: flex-end;
    @media (min-width: 1440px) {
      width: auto;
      text-align: left;
    }
  }

  .legendItem div {
    font-size: 12px;
  }

  .legendItem:before {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 12px;
    background-color: currentColor;
    flex: 0 0 10px;
    @media (min-width: 1440px) {
      margin-right: 6px;
    }
  }

  .legendItem:nth-child(2) {
    color: #71bc7e;
  }

  .legendItem:nth-child(3) {
    color: #5a8dca;
    div {
      width: 45px;
    }
    @media (min-width: 1440px) {
      div {
        width: auto;
      }
    }
  }
  .legendItem:nth-child(4) {
    color: #a7d4ea;
  }

  .repsWrap {
    display: flex;
    height: 100%;
    justify-content: flex-start;
    margin-top: 40px;
    max-height: calc(100% - 50px);
  }

  .columnWrap {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    flex-wrap: wrap;
    /* overflow: auto; */
    gap: 10px;
    margin-right: 10px;
  }

  .columnWrap_National {
    color: #d4c92c;
  }
  .columnWrap_TX {
    color: #71bc7e;
  }
  .columnWrap_NJ_PA {
    color: #5a8dca;
  }
  .columnWrap_NY {
    color: #a7d4ea;
  }

  /* --- TABLE DETAILS --- */

  .data-table {
    grid-column: 3 / 4;
    grid-row: 1 / 4;
    background-color: #1a253e;
    border-radius: 5px;
    color: #fff;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .table-container {
    overflow: auto;
    position: relative;
    height: 100%;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    .stateCell {
      width: 64px;
      text-align: center;
    }
    .amountCell {
      width: 110px;
    }
    .linkCell {
      width: 65px;
    }
  }

  th,
  td {
    font-size: 12px;
    font-weight: 700;
    height: 58px;
    letter-spacing: 0.5px;
    padding: 12px 8px;
    text-align: left;
    width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    :first-of-type {
      width: 36px;
      padding-left: 12px;
      color: #5a8dca;
    }
  }

  th {
    background-color: #1a253e;
    color: #5a8dca;
    padding: 16px;
    text-transform: uppercase;
    position: sticky;
    top: 0;
    z-index: 2;
  }

  tbody tr:nth-child(odd) {
    background-color: #212d49;
  }
`;

export const SelectSalesRepWrap = styled.div`
  height: calc(100% - 58px);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  div {
    font-size: 20px;
    font-weight: 700;
  }
`;

export const PersonCircleWrap = styled.div<{ isSelected?: boolean; small?: boolean }>`
  align-items: center;
  background-color: ${({ isSelected: current }) => (current ? "currentColor" : "transparent")};
  border-radius: 50%;
  border: 1px solid currentColor;
  display: flex;
  font-size: 10px;
  font-weight: 600;
  height: 58px;
  justify-content: center;
  padding: 0 10px;
  position: relative;
  transition: all 0.2s ease;
  width: 58px;
  cursor: ${({ isSelected: current }) => (current ? "default" : "pointer")};

  span {
    color: ${({ isSelected: current }) => (current ? "#212D49" : "currentColor")};
    transition: all 0.2s ease;
  }

  :hover {
    background-color: currentColor;
    span {
      color: #212d49;
    }
  }

  .smallName {
    position: relative;
    top: -2px;
    font-size: 9px;
  }

  .orderCountBadge {
    position: absolute;
    top: -4px;
    right: -2px;
    background-color: #4b8bfc;
    color: white;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
  }
`;

export const MonthSelectorWrap = styled.div`
  align-items: center;
  background-color: #060f16;
  display: flex;
  gap: 16px;
  height: 64px;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 8px 28px 0;
  > img {
    height: auto;
    max-width: 120px;
    object-fit: contain;
    width: 100%;
  }
  .monthSelectorWrap {
    display: flex;
    gap: 12px;
    overflow-x: auto;
  }
  .monthSelector {
    align-items: center;
    background: #1a253e;
    border-radius: 5px;
    color: #fff;
    cursor: pointer;
    display: flex;
    font-size: 12px;
    font-weight: 700;
    height: 32px;
    justify-content: center;
    padding: 0 12px;
    width: 85px;
    :hover {
      background-color: #5d81b5;
    }
  }
  .selected {
    cursor: default;
    background-color: #5d81b5;
  }
  @media (min-width: 1440px) {
    padding-top: 0;
    align-items: flex-end;
    > img {
      max-width: 160px;
    }
    .monthSelector {
      height: 40px;
    }
  }
`;

export function LoadingSpinner() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
      <circle fill="none" strokeOpacity="1" stroke="#5a8dca" strokeWidth=".5" cx="100" cy="100" r="0">
        <animate
          attributeName="r"
          calcMode="spline"
          dur="2"
          values="1;80"
          keyTimes="0;1"
          keySplines="0 .2 .5 1"
          repeatCount="indefinite"
        ></animate>
        <animate
          attributeName="stroke-width"
          calcMode="spline"
          dur="2"
          values="0;25"
          keyTimes="0;1"
          keySplines="0 .2 .5 1"
          repeatCount="indefinite"
        ></animate>
        <animate
          attributeName="stroke-opacity"
          calcMode="spline"
          dur="2"
          values="1;0"
          keyTimes="0;1"
          keySplines="0 .2 .5 1"
          repeatCount="indefinite"
        ></animate>
      </circle>
    </svg>
  );
}

export function LoadingBubbles() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
      <circle fill="#5a8dca" stroke="#5a8dca" strokeWidth="15" r="15" cx="40" cy="100">
        <animate
          attributeName="opacity"
          calcMode="spline"
          dur="2"
          values="1;0;1;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="-.4"
        ></animate>
      </circle>
      <circle fill="#5a8dca" stroke="#5a8dca" strokeWidth="15" r="15" cx="100" cy="100">
        <animate
          attributeName="opacity"
          calcMode="spline"
          dur="2"
          values="1;0;1;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="-.2"
        ></animate>
      </circle>
      <circle fill="#5a8dca" stroke="#5a8dca" strokeWidth="15" r="15" cx="160" cy="100">
        <animate
          attributeName="opacity"
          calcMode="spline"
          dur="2"
          values="1;0;1;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="0"
        ></animate>
      </circle>
    </svg>
  );
}
